import moment from 'moment'




export const getInitialDates = () => {
  const year = moment().year()
  
  const fromDateObj = moment({year, month: 3, day: 15})
  const toDateObj = moment() > fromDateObj ? moment() : fromDateObj

  const from_date = fromDateObj.format('DD.MM')
  const to_date = toDateObj.format('DD.MM')

  return {from_date, to_date}
}


const getStudentGroup = student => {
  if (student.L === '1' || student.L1 === '1') return 0
  if (student.M === '1' || student.N === '1') return 1
  return 2
}

const compareByFio = (a, b) => {
  const fioA = `${a.child_lastname ?? ''} ${a.child_firstname ?? ''} ${a.child_midname ?? ''}`
  const fioB = `${b.child_lastname ?? ''} ${b.child_firstname ?? ''} ${b.child_midname ?? ''}`
  return fioA.localeCompare(fioB, 'ru')
}

const sortStudents = students => [...students].sort((a, b) => {
  const groupA = getStudentGroup(a)
  const groupB = getStudentGroup(b)
  if (groupA !== groupB) return groupA - groupB

  if (groupA === 0) return compareByFio(a, b)

  const ballDiff = Number(b.Ball) - Number(a.Ball)
  if (ballDiff !== 0) return ballDiff
  return compareByFio(a, b)
})

export const getModifyData = (list, stat) => {
  if (!list?.length) return []

  const statMap = {}
  for (const s of stat ?? []) {
    statMap[`${s.idOrganization}_${s.kurs}`] = { fact: s.fact, plan: s.plan }
  }

  const orgMap = {}

  for (const item of list) {
    const { idOrganization, Orgname, child_class } = item

    if (!orgMap[idOrganization]) {
      orgMap[idOrganization] = {
        idOrganization,
        Orgname,
        classes: {},
      }
    }

    if (!orgMap[idOrganization].classes[child_class]) {
      orgMap[idOrganization].classes[child_class] = []
    }

    orgMap[idOrganization].classes[child_class].push(item)
  }

  return Object.values(orgMap).map(org => ({
    ...org,
    classes: Object.entries(org.classes)
      .sort(([a], [b]) => Number(a) - Number(b))
      .map(([child_class, students]) => {
        const { fact, plan } = statMap[`${org.idOrganization}_${child_class}`] ?? {}
        return {
          child_class,
          students: sortStudents(students),
          fact: Number(fact) || 0,
          plan: Number(plan) || 0
        }
      }),
  }))
}

const getJoinDate = (year, date) => {
  const [DD, MM] = date.split('.')
  return `${year}-${MM}-${DD}`
}

export const getQueryParams = params => {
  const from_date = getJoinDate(params.year, params.from_date)
  const to_date = getJoinDate(params.year, params.to_date)
  return { ...params, from_date, to_date }
}